module.exports = __webpack_public_path__ + "img/editor-header.066c6a81.svg";